export const GALLERY_SIZE = 12
